import { Controller } from "@hotwired/stimulus"

// This controller toggles visibility of wallet action forms on the advocate
// show page. Use it with a button that triggers the `toggle` action and wraps
// the action section.
//
// Example usage:
// <div data-controller="wallet-actions">
//   <button data-action="wallet-actions#toggle">Wallet Actions</button>
//   <div data-wallet-actions-target="actions" class="hidden">
//     <!-- forms -->
//   </div>
// </div>
export default class extends Controller {
  static targets = ["actions"]

  toggle(e) {
    e.preventDefault()
    this.actionsTarget.classList.toggle("hidden")
  }
}
